<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="activityId" v-if="formType === 2">
        <span slot="label" ><a-tooltip>{{ $t('活动ID') }}<template slot="title">{{ $t('活动ID') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.activityId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'活动ID'" />
      </a-form-model-item>
      <a-form-model-item prop="userId" v-if="formType === 2">
        <span slot="label" ><a-tooltip>{{ $t('申请用户ID') }}<template slot="title">{{ $t('申请用户ID') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.userId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'申请用户ID'" />
      </a-form-model-item>
      <a-form-model-item prop="applyType" >
        <span slot="label" ><a-tooltip>{{ $t('申请类型') }}<template slot="title">{{ $t('申请类型') }}</template></a-tooltip> </span>
        <a-select v-model="form.applyType" :placeholder="$t('请选择')+'申请类型'">
          <a-select-option :value="10">COSER</a-select-option>
          <a-select-option :value="20">摄影师</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="applyLevelId" >
        <span slot="label" ><a-tooltip>{{ $t('申请等级ID') }}<template slot="title">{{ $t('申请等级ID') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.applyLevelId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'申请等级ID'" />
      </a-form-model-item>
      <a-form-model-item prop="cnName" >
        <span slot="label" ><a-tooltip>{{ $t('CN名称') }}<template slot="title">{{ $t('CN名称') }}</template></a-tooltip> </span>
        <a-input v-model="form.cnName" :maxLength="128" :placeholder="$t('请输入')+'CN名称'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="roleName" >
        <span slot="label" ><a-tooltip>{{ $t('认证角色名称') }}<template slot="title">{{ $t('认证角色名称') }}</template></a-tooltip> </span>
        <a-input v-model="form.roleName" :maxLength="128" :placeholder="$t('请输入')+'认证角色名称'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="realName" >
        <span slot="label" ><a-tooltip>{{ $t('真实姓名') }}<template slot="title">{{ $t('真实姓名') }}</template></a-tooltip> </span>
        <a-input v-model="form.realName" :maxLength="64" :placeholder="$t('请输入')+'真实姓名'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="phone" >
        <span slot="label" ><a-tooltip>{{ $t('联系方式') }}<template slot="title">{{ $t('联系方式') }}</template></a-tooltip> </span>
        <a-input v-model="form.phone" :maxLength="32" :placeholder="$t('请输入')+'联系方式'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="applyStatus" >
        <span slot="label" ><a-tooltip>{{ $t('审核状态') }}<template slot="title">{{ $t('审核状态') }}</template></a-tooltip> </span>
      </a-form-model-item>
      <a-form-model-item prop="auditReason" >
        <span slot="label" ><a-tooltip>{{ $t('审核原因') }}<template slot="title">{{ $t('审核原因') }}</template></a-tooltip> </span>
        <a-input v-model="form.auditReason" :maxLength="255" :placeholder="$t('请输入')+'审核原因'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="scoreReward" >
        <span slot="label" ><a-tooltip>{{ $t('审核通过奖励积分') }}<template slot="title">{{ $t('审核通过奖励积分') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.scoreReward" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'审核通过奖励积分'" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getCommunityGroupActivityCoserApply, addCommunityGroupActivityCoserApply, updateCommunityGroupActivityCoserApply } from '@/api/community/communityGroup/communityGroupActivityCoserApply'
  import { mapGetters } from 'vuex'
  import CustomDictTag from '@/components/DictCustomTag'
  import { generateFilePath, uploadObject } from '@/api/tool/oss'
  import LocaleFieldButton from '@/components/locale/LocaleFieldButton.vue'
  import moment from 'moment'

  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        activityId: null,
        userId: null,
        applyType: 10,
        applyLevelId: null,
        cnName: null,
        roleName: null,
        realName: null,
        phone: null,
        applyStatus: 0,
        auditReason: null,
        scoreReward: null,
        localeFieldMap: {}
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
          cnName: [{ required: true, message: this.$t('CN名称') + this.$t('不能为空'), trigger: 'blur' }],
          roleName: [{ required: true, message: this.$t('认证角色名称') + this.$t('不能为空'), trigger: 'blur' }],
          realName: [{ required: true, message: this.$t('真实姓名') + this.$t('不能为空'), trigger: 'blur' }],
          phone: [{ required: true, message: this.$t('联系方式') + this.$t('不能为空'), trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    moment,
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        activityId: null,
        userId: null,
        applyType: 10,
        applyLevelId: null,
        cnName: null,
        roleName: null,
        realName: null,
        phone: null,
        applyStatus: 0,
        auditReason: null,
        scoreReward: null,
        localeFieldMap: {}
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCommunityGroupActivityCoserApply({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCommunityGroupActivityCoserApply(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addCommunityGroupActivityCoserApply(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
